export var ChangeRsvpModalMode;
(function (ChangeRsvpModalMode) {
    ChangeRsvpModalMode["WAITLIST"] = "waitlist";
    ChangeRsvpModalMode["DELETE"] = "delete";
    ChangeRsvpModalMode["UPDATE_TO_NO"] = "update-to-no";
    ChangeRsvpModalMode["UPDATE_TO_YES"] = "update-to-yes";
    ChangeRsvpModalMode["MEMBERS_PAGE"] = "members-page-cancel";
})(ChangeRsvpModalMode || (ChangeRsvpModalMode = {}));
export var MembersModal;
(function (MembersModal) {
    MembersModal["LIST"] = "members-modal";
    MembersModal["UPDATE_RSVP"] = "member-update-rsvp";
    MembersModal["NO_CANCEL_RSVP"] = "no-cancel-rsvp-in-preview";
})(MembersModal || (MembersModal = {}));
//# sourceMappingURL=modals.js.map